import React from 'react';
import Select from '../../../engine/SelectEngine';

const UserLookupFieldSelectView = props => {
  return (
    <Select
      disabled={!props.userLookupFields || !props.userLookupFields.length}
      variant={props.variant}
      placeholder={'Choose field'}
      customCSS={props.customCSS || 'margin-left: 0.8rem !important;'}
      fullWidth={props.fullWidth}
      value={props.lookupFieldId}
      onChange={value =>
        props.update({
          lookupFieldId: value
        })
      }
      options={props.userLookupFields.map(f => ({
        value: f.internalId,
        text: f.title || 'Untitled user lookup field',
        'data-testid': `lookup-${f.internalId}`
      }))}
    />
  );
};

export default UserLookupFieldSelectView;
